<template>
    <v-row>
        <v-card-text>
            <p class="body-1">{{ $t('oampublication/label--chainstaff-adbudget-description') }}</p>
            <ValidationProvider
                v-slot="{ errors }"
                :name="$t('oampublication/label--chainstaff-adbudget')"
                rules="required|numeric|chainstaff_min_value:500"
            >
                <v-text-field
                    v-model="chainstaffBountyChf"
                    type="number"
                    prefix="CHF"
                    :label="$t('oampublication/label--chainstaff-adbudget')"
                    :hint="$t('oampublication/label--chainstaff-adbudget-description')"
                    :error-messages="errors"
                >
                </v-text-field>
            </ValidationProvider>
        </v-card-text>
    </v-row>
</template>

<script>
import { extend } from 'vee-validate'
import { min_value } from 'vee-validate/dist/rules'
import { ValidationProvider } from 'vee-validate'
import { mapGetters, mapActions } from 'vuex'
import Vue from 'vue'

extend('chainstaff_min_value', {
    ...min_value,
    message: () => {
        return Vue.i18n.translate('oampublication/message--chainstaff-adbudget-min-value')
    },
})

export default {
    components: {
        ValidationProvider,
    },
    data: () => ({
        connectorId: -37,
        loading: true,
    }),
    computed: {
        ...mapGetters('pub', ['getExtensionValueByKey']),
        chainstaffBountyChf: {
            get: function () {
                return this.getExtensionValueByKey('ChainstaffBountyCHF')
            },
            set: function (val) {
                this.editExtension({ key: 'ChainstaffBountyCHF', value: val })
            },
        },
    },
    mounted() {
        this.loading = false
        this.$emit('child-rendered')
    },
    methods: {
        ...mapActions('pub', ['editExtension']),
    },
}
</script>

<style scoped></style>
